import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsis } from "@fortawesome/free-solid-svg-icons";
import AlertActionsDropdown from "../AlertActionsDropdown";
import { resolveActionLabel } from "./lostTerminalAlertsUtils";

export default function LostTerminalActionsMenu({
  item,
  disabled = false,
  onManage,
  onTake,
  onAssign,
  onRelease,
  onCopyMessage,
}) {
  const actionLabel = resolveActionLabel(item);
  const actions = [
    item.canTake ? { key: "take", label: "Tomar caso", onSelect: () => onTake?.(item.raw) } : null,
    item.canAssign ? { key: "assign", label: "Asignar", onSelect: () => onAssign?.(item.raw) } : null,
    item.canRelease ? { key: "release", label: "Liberar", onSelect: () => onRelease?.(item.raw) } : null,
    { key: "manage", label: actionLabel, onSelect: () => onManage?.(item.raw) },
    item.suggestedMessage ? { key: "copy", label: "Copiar mensaje", onSelect: () => onCopyMessage?.(item.suggestedMessage) } : null,
  ].filter(Boolean);

  return (
    <AlertActionsDropdown items={actions} disabled={disabled} ariaLabel={`Acciones para ${item.commerceName}`} toggleClassName="lost-terminal-alert-card__actions-toggle">
        <span>Acciones</span>
        <FontAwesomeIcon icon={faEllipsis} />
    </AlertActionsDropdown>
  );
}
